// Testimonials.jsx
import React, { useState } from "react";
import styles from "./Testimonials.module.css";

const testimonials = [
  { id: 1, quote: "ToxBox AI Interview Agent cut our scheduling time in half and improved candidate experience significantly.", author: "Sarah J., Tech Company X", rating: 5 },
  { id: 2, quote: "Objective candidate scoring helped us hire the best talent without bias.", author: "Michael Chen, Healthcare Agency", rating: 5 },
  { id: 3, quote: "With ToxBox AI, we reduced interview no-shows by 40% and gained deeper insights into candidate performance.", author: "Emma Williams, Sales Manager", rating: 5 },
  { id: 4, quote: "Incredible time-saver for high-volume hiring.", author: "David Park, Recruitment Lead", rating: 5 },
  { id: 5, quote: "The most powerful AI recruiting tool we've used.", author: "Lisa Rodriguez, HR Director", rating: 5 },
  { id: 6, quote: "Reduced bias and improved quality of hire dramatically.", author: "James Liu, Fortune 500 Company", rating: 5 },
];

// Helper to generate a nice random avatar based on the person's name
// const generateAvatar = (name) => {
//   const namePart = name.split(",")[0].trim().replace(/\s+/g, "+");
//   return `https://api.dicebear.com/7.x/avataaars/svg?seed=${namePart}&backgroundColor=ffd5ba,b6e3f4,c0aede,d1d4f9`;

//   return `https://ui-avatars.com/api/?name=${namePart}&background=random&rounded=true&size=80`;
// };


// Add this helper at the top (outside the component)
const randomUserCache = new Map(); // Simple cache so same person keeps same photo

const getRealPersonAvatar = (author) => {
  const key = author.split(",")[0].trim(); // Use name as seed
  if (randomUserCache.has(key)) {
    return randomUserCache.get(key);
  }

  // Generate a consistent but random-looking real person
  const seed = key.split("").reverse().join("") + key.length;
  const url = `https://randomuser.me/api/portraits/${Math.random() > 0.5 ? "men" : "women"}/${Math.floor(Math.random() * 99)}.jpg`;

  randomUserCache.set(key, url);
  return url;
};

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(1);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const prevIndex = currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1;
  const nextIndex = currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1;

  const renderCard = (index) => {
    const t = testimonials[index];
    return (
      <div className={`${styles.card} ${index === currentIndex ? styles.active : index === prevIndex ? styles.prev : styles.next}`}
        onClick={() => index !== currentIndex && goToSlide(index)}>

        {/* Circular Avatar */}
        <div className={styles.avatar}>
          <img
            src={getRealPersonAvatar(t.author)}
            alt={t.author.split(",")[0]}
            className={styles.avatarImg}
            loading="lazy"
          />
        </div>

        <p className={styles.quote}>“{t.quote}”</p>
        <div className={styles.footer}>
          <span className={styles.author}>{t.author.split(",")[0]}</span>
          <div className={styles.stars}>
            {[...Array(5)].map((_, i) => (
              <span key={i} className={styles.star}>★</span>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className={styles.testimonialsSection}>
      <div className={styles.container}>
        <h2 className={styles.title}>Testimonials</h2>
        <p className={styles.subtitle}>
      Companies Are <span className={styles.purpleText}>Hiring</span> Smarter and Faster
    </p>

        <div className={styles.carousel}>
          <div className={styles.cardsWrapper}>
            {renderCard(prevIndex)}
            {renderCard(currentIndex)}
            {renderCard(nextIndex)}
          </div>
        </div>

        {/* Dots */}
        <div className={styles.dots}>
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`${styles.dot} ${index === currentIndex ? styles.activeDot : ""}`}
              aria-label={`Testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;